import React, { useEffect } from "react"
import { Button, Card, Popconfirm, Tree } from "antd";
import { YhBox } from "../../../../../components/YhBox";
// import { useDictModel } from "../../dict/dictModel"
import { globalPrompt } from "../../../../../components/YhMessage"
import { useOrganizationModel } from "../organizationModel"
import { IOrganDetail, OptType } from "../organizationTypes"
function containsChildByKey(node: IOrganDetail, key: React.Key): any {
    if (node.hasOwnProperty("children")) {
        for (let childNode of node.children as IOrganDetail[]) {
            if (childNode) {
                if (childNode.key === key) {
                    return node;
                }
                const ret = containsChildByKey(childNode, key);
                if (ret != null) {
                    return ret;
                }
            }
        }
    }
}

function getPNodeByKey(key: React.Key, initTreeData: IOrganDetail[]) {
    for (let node of initTreeData) {
        const pNode = containsChildByKey(node, key)
        if (pNode != null) {
            return pNode;
        }
    }
}

const OrganTree = () => {
    const { searchParam,organTree, organTreePRow, organTreeRow, organTreeRowKey, root, setOptType, setRoot, setAddTreeFrom,removeTreeForm, loadData, setOrganTreeRowKey, setOrganTreeRow, setOrganTreePRow,} = useOrganizationModel()
    useEffect(() => {
        loadData()
    }, [])
    const addPeer = () => {
        let rowCode = organTreeRow.code as string
        let rowCodeSlice = rowCode?.slice(0, rowCode.length - 1)
        let pcodeLen = organTreePRow?.children?.length as number
        if (organTreePRow) {
            setAddTreeFrom({
                pcode: organTreeRow.pcode,
                code: rowCodeSlice + (pcodeLen + 1),
                branch:'main',
                enable:1
            })
            setRoot(true)
        } else {//当前选中为根级元素的时候，他的字典编码是可以自定义编辑的
            setRoot(false)
            setAddTreeFrom({})
        }
        setOptType(OptType.ADD_SAME_LEVEL);

    }
    const addSon = () => {
        const { children, code } = organTreeRow
        let dictRowLen = children?.length as number
        setAddTreeFrom({
            pcode: code,
            code: `${code}-0${dictRowLen >= 10 ? dictRowLen + 1 : '0' + (dictRowLen + 1)}`,
            branch:'main',
            enable:1
        })
        setRoot(true)
        setOptType(OptType.ADD_CHILD_LEVEL);
    }
    const remove = ()=>{
        if(organTreeRowKey.length==0){
            return globalPrompt("message",{type:"error",text:"请先选择要删除的值"})
        }
        removeTreeForm()
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            // disabled={organTreeRowKey.length==0}
            onClick={() => addPeer()}
        >增加同级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={organTreeRowKey.length==0}
            onClick={() => addSon()}
        >增加下级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => remove()}
        >删除</Button>
    </>
    const onSelect = (selectedKeys: React.Key[], info: any) => {
        const selectedNode = info.selectedNodes[0];
        const pNode = getPNodeByKey(selectedKeys[0], organTree)
        setRoot(true)
        setOrganTreePRow(pNode)
        setOrganTreeRow(selectedNode)
        setOrganTreeRowKey(selectedKeys)
        setOptType(OptType.DETAIL)
    }
    const onCheck = () => {

    }
    return <YhBox action={action} title="字典目录" width="500px">
        <Tree
            className="p-15"
            treeData={organTree}
            titleRender={(node: any) => `${node.name}`}
            selectedKeys={organTreeRowKey}
            onSelect={onSelect}
            onCheck={onCheck}
        />
    </YhBox>
}
export default OrganTree